export default [
  {
    path: '/connectors',
    name: 'r_connector-types',
    meta: {
      middlewares: {
        auth: null,
        permission: 'CONNECTORS',
      },
    },
    component: () => import('../../components/connectors/ConnectorTypes'),
    children: [
      {
        path: 'connectors-overview',
        name: 'r_connectors',
        meta: {
          middlewares: {
            auth: null,
            permission: 'CONNECTORS',
          },
        },
        component: () => import('../../components/connectors/Connectors'),
        children: [
          {
            path: 'connector',
            name: 'r_connector',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/Connector'),
          },
        ],
      },
      {
        path: 'connectors-sso',
        name: 'r_connectors-sso',
        meta: {
          middlewares: {
            auth: null,
            permission: 'CONNECTORS',
          },
        },
        component: () => import('../../components/connectors/Ssos'),
        children: [
          {
            path: 'list/:ssoId',
            name: 'r_connectors-sso-list',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/sso/SsoDomainList'),
            props: true,
          },
          {
            path: ':ssoId/edit/:ssoFieldId',
            name: 'r_connectors-azure-sso-field-edit',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/sso/EditAzureSsoField'),
          },
          {
            path: ':ssoId/edit/:ssoFieldId',
            name: 'r_connectors-google-sso-field-edit',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/sso/EditGoogleSsoField'),
          },
          {
            path: ':ssoId/add',
            name: 'r_connectors-azure-sso-field-add',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/sso/AddSsoAzure'),
          },
          {
            path: ':ssoId/add',
            name: 'r_connectors-google-sso-field-add',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/sso/AddSsoGoogle'),
          },
        ],
      },
      {
        path: 'connectors-calendar',
        name: 'r_connectors-calendar',
        meta: {
          middlewares: {
            auth: null,
            permission: 'CONNECTORS',
          },
        },
        component: () => import('../../components/connectors/Calendars'),
        children: [
          {
            path: 'list/:calendarId',
            name: 'r_connectors-calendar-list',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/CalendarDomains'),
            props: true,
          },
          {
            path: ':calendarId/edit/:calendarFieldId',
            name: 'r_connectors-outlook-calendar-field-edit',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/EditOutlookCalendarField.vue'),
          },
          {
            path: ':calendarId/edit/:calendarFieldId',
            name: 'r_connectors-google-calendar-field-edit',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/EditGoogleCalendarField.vue'),
          },
          {
            path: ':calendarId/add',
            name: 'r_connectors-outlook-calendar-field-add',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/AddOutlookCalendarField.vue'),
          },
          {
            path: ':calendarId/add',
            name: 'r_connectors-google-calendar-field-add',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/AddGoogleCalendarField.vue'),
          },
        ],
      },
      {
        path: 'connectors-intranet',
        name: 'r_connectors-intranet',
        meta: {
          middlewares: {
            auth: null,
            permission: 'CONNECTORS',
          },
        },
        component: () => import('../../components/connectors/Intranets'),
        children: [
          {
            path: 'add',
            name: 'r_connectors-intranet-add',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/AddIntranet'),
          },
          {
            path: 'edit/:intranetId',
            name: 'r_connectors-intranet-edit',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/EditIntranet'),
          },
        ],
      },
    ],
  },
  {
    path: '/company-connectors',
    name: 'r_connector-types-company',
    meta: {
      middlewares: {
        auth: null,
        permission: 'CONNECTORS',
      },
    },
    component: () => import('../../components/connectors/ConnectorTypes'),
    children: [
      {
        path: 'connectors-overview',
        name: 'r_connectors-company',
        meta: {
          middlewares: {
            auth: null,
            permission: 'CONNECTORS',
          },
        },
        component: () => import('../../components/connectors/Connectors'),
        children: [
          {
            path: 'connector',
            name: 'r_connector-company',
            meta: {
              middlewares: {
                auth: null,
                permission: 'CONNECTORS',
              },
            },
            component: () => import('../../components/connectors/Connector'),
          },
        ],
      },
    ],
  },
];
